export const BRAND_MAPPINGS_RESET_STATE = 'BRAND_MAPPINGS_RESET_STATE';
export const BRAND_MAPPINGS_CURRENT_ITEM = 'BRAND_MAPPINGS_CURRENT_ITEM';

export const BRAND_MAPPINGS_REQUEST_LOADING = 'BRAND_MAPPINGS_REQUEST_LOADING';
export const BRAND_MAPPINGS_REQUEST_SUCCESS = 'BRAND_MAPPINGS_REQUEST_SUCCESS';
export const BRAND_MAPPINGS_REQUEST_FAILED = 'BRAND_MAPPINGS_REQUEST_FAILED';

export const BRAND_MAPPINGS_CURRENT_ACTION = 'BRAND_MAPPINGS_CURRENT_ACTION';
export const BRAND_MAPPINGS_RESET_ACTION = 'BRAND_MAPPINGS_RESET_ACTION';